/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { Button, Modal } from '@mairistem/composants';

import { TypeListePacs } from '@/enums';
import type { TypePacs } from '@/types';
import PacsListeContainer from '@/components/Pacs/Liste/PacsListeContainer';

interface PacsModalProps {
  open: boolean;
  title?: string;
  datePacs?: string | null;
  typePacs?: TypePacs | null;
  stats?: boolean;
  onClose: () => void;
}

const PacsModal = (props: PacsModalProps) => {
  const { open, title, datePacs, typePacs, stats, onClose } = props;

  return (
    <Modal
      open={open}
      onClose={onClose}
      size="large"
      closeIcon
      data-testid="pacs-modal"
    >
      <Modal.Header content={title} />
      <Modal.Content style={{ height: '700px' }}>
        <div style={{ height: '560px' }}>
          <PacsListeContainer
            data-testid="pacs-liste-modal-statistiques"
            datePacs={datePacs}
            typePacs={typePacs}
            stats={stats}
            typeListe={TypeListePacs.ToutPacs}
            modal
            projet={typePacs === 'Projet'}
          />
        </div>
      </Modal.Content>
      <Modal.Actions>
        <Button
          basic
          size="small"
          icon="close"
          data-testid="pacs-modal-fermer"
          content="Fermer"
          onClick={onClose}
        />
      </Modal.Actions>
    </Modal>
  );
};

export default PacsModal;
